import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { GlobalNodeMenuItem } from './globalNodeBadge';

/**
 * Shared ⋮ menu for Global-eligible nodes: Global convert + Delete.
 */
export default function NodeHeaderActionsMenu({
  nodeId,
  editable = true,
  iconColor = '#6B7280',
  onDelete,
  title = 'Node actions',
  children
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);

  const closeMenu = () => setMenuAnchorEl(null);

  const openMenu = e => {
    e.preventDefault();
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
  };

  const handleDelete = e => {
    closeMenu();
    onDelete?.(e);
  };

  return (
    <>
      <IconButton
        onClick={openMenu}
        className="header-delete-icon"
        title={title}
        disabled={!editable}
        size="small"
      >
        <MoreVertIcon style={{ color: iconColor }} />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        getContentAnchorEl={null}
      >
        <GlobalNodeMenuItem
          nodeId={nodeId}
          editable={editable}
          onClick={closeMenu}
        />
        {children}
        {onDelete && (
          <MenuItem onClick={handleDelete} disabled={!editable}>
            <DeleteOutlineIcon
              fontSize="small"
              style={{ marginRight: '8px', color: '#dc3545' }}
            />
            Delete Node
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
